import useInstagramFeed from './hooks/useInstagramFeed.js';
import { Container, Header, Content, Nav, Navbar, Footer } from "rsuite"
import 'rsuite/dist/rsuite.min.css'
import './App.css';
import React from 'react';

function App() {
  const { feed } = useInstagramFeed(process.env.REACT_APP_PROFILE_ID)
  const estiloGeneral = {
    numColumnas: 3,
    padding: "3px",
  }
  const estiloPost = {
    maxWidth: `calc( ${100/estiloGeneral.numColumnas}% - 2 * ${estiloGeneral.padding} )`,
    minWidth: `calc( ${100/estiloGeneral.numColumnas}% - 2 * ${estiloGeneral.padding} )`,
    background: "grey",
    padding: estiloGeneral.padding,
  };
  const estiloImagen = { 
    border: "1px solid black",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    width: "100%",
    paddingTop: `calc( 100% - ${estiloGeneral.padding} )`,
  };
  const estiloWidget = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    maxHeight: "calc(100vh - 106px)",
    overflowY: "scroll",
  };

  const ripple = function (e) {
    console.log(e)
    // Create span element
    let ripple = document.createElement("span");

    // Add ripple class to span
    ripple.classList.add("ripple");

    // Add span to the button 
    e.target.appendChild(ripple);

    // Get position of X
    let x = e.clientX - e.target.offsetLeft;

    // Get position of Y 
    let y = e.clientY - e.target.offsetTop;

    // Position the span element
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;

    // Remove span after 0.3s
    setTimeout(() => {
      ripple.remove();
    }, 300);
  }

  return (
    <Container className="App">
      <Header>
        <Navbar>
          <Nav>
            <Nav.Item disabled
              style={{ height: 18 }}
              >
              {`@${process.env.REACT_APP_PROFILE_ID}`}
            </Nav.Item>
          </Nav>
          <Nav pullRight>
            <Nav.Item style={{ height: 18 }} 
              href={`https://www.instagram.com/${process.env.REACT_APP_PROFILE_ID}/`}
              target="_blank"
            >
              Síganos en
              <img width={24} style={{ paddingLeft: 4 }}
                src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fupload.wikimedia.org%2Fwikipedia%2Fcommons%2Fthumb%2Fe%2Fe7%2FInstagram_logo_2016.svg%2F132px-Instagram_logo_2016.svg.png&f=1&nofb=1&ipt=cbe19b8e627bb780898412d206d06facb592a0f48b66e67f97d7dd359eb06e15&ipo=images' 
              />
            </Nav.Item>
          </Nav>
        </Navbar>
      </Header>
      <Content className='Posts' style={estiloWidget}>
        {feed?.posts?.length > 1 && feed.posts.map(post => (
          <div style={estiloPost} key={post.href}>
            <a href={post.href} target="_blank" onClick={e => ripple(e)}>
              {/* TODO Hacer esto su propio componente */}
              <div className='Contenedor' style={{ 
                background: `url(${process.env.REACT_APP_API_URL}/${post.imgSrc})`, 
                ...estiloImagen, 
              }}>
                <div className='Overlay' style={{
                }}>
                  Ver {" "}
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>
                </div>
              </div>
            </a>
          </div>
        ))}
      </Content>
      <Footer style={{ textAlign: 'center', padding: "8px" }}>
        Elaborado por 
        <a href='https://labsolutions.com.ec/' target="_blank">
          <img src="https://labsolutions.com.ec/assets/img/logo_bg_4.png" height={36} />
        </a>
      </Footer>
    </Container>
  );
}

export default App;
